import { AgencyService } from './../../../api/agency.service';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-social-icons-base',
  templateUrl: './social-icons-base.component.html',
  styleUrls: ['./social-icons-base.component.scss']
})

export class SocialIconsBaseComponent {
  @Input() isTooltipBelow: boolean;

  constructor(public agencyService: AgencyService) { }
}



// WEBPACK FOOTER //
// ./src/app/common-theme/base-components/shared/social-icons-base/social-icons-base.component.ts